module.exports = "/_next/static/images/OptimizeTheFirstTimeUserExperience@3x-1fa3e16a2be4b1540d84b7f1259951d2.webp";